<template>
  <div id="rightMainContainer" style="width:100%">
    <operations></operations>
    <div style="height:var(--middle-space);background:#f4f5fa"></div>
    <fileTable ref="goodslist"></fileTable>
  </div>
</template>

<script>
import fileTable from "./fileTable/fileTable";
import operations from "./operations/operations";
export default {
  name: "Mycollection",
  components: {
    fileTable,
    operations
  },
  data() {
    return {};
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#rightMainContainer {
  height: 100%;
  background-color: #fff;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: flex;
  flex-direction: column;
}
::v-deep span{
  font-size: 14px !important;
}
::v-deep .cell{
  font-size: 14px !important;
}
</style>
